module.exports = __webpack_public_path__ + "img/icon_rail.9072ef9e.png";